import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { IconBack } from '@belong/icons/dist/IconBack';
import { Formik, useFormikContext } from 'formik';
import { Button } from '../Button/Button.js';
import { ButtonBase } from '../ButtonBase/ButtonBase.js';
import { Desktop } from '../Desktop/Desktop.js';
import { Mobile } from '../Mobile/Mobile.js';
import { Text } from '../Text/Text.js';

function Form({
  children,
  ...props
}) {
  return jsx(Formik, {
    ...props,
    children: formikProps => jsx("form", {
      onReset: formikProps.handleReset,
      onSubmit: formikProps.handleSubmit,
      className: "contents",
      children: children(formikProps)
    })
  });
}
/**
 * Scrolls to the first form error element on mobile devices
 */
function scrollToFirstError() {
  // Only run on mobile devices
  if (window.innerWidth >= 768) return;
  // Find the first error message element
  const firstErrorElement = document.querySelector('.text-red');
  if (firstErrorElement) {
    // Calculate position to scroll to
    const elementRect = firstErrorElement.getBoundingClientRect();
    const absoluteElementTop = elementRect.top + window.pageYOffset;
    // Use fixed offset from top to ensure visibility below fixed headers
    // and above fixed footers consistently
    const scrollPosition = absoluteElementTop - 150;
    window.scrollTo({
      top: scrollPosition,
      behavior: 'smooth'
    });
  }
}
function SubmitButton(props) {
  const form = useFormikContext();
  const handleClick = e => {
    // Force validation before checking errors
    form.validateForm().then(errors => {
      // Check if there are any validation errors
      if (Object.keys(errors).length > 0) {
        // If form has errors, scroll to first error
        setTimeout(() => scrollToFirstError(), 100);
      }
    });
    // Call the original onClick if it exists
    if (props.onClick) {
      props.onClick(e);
    }
  };
  return jsx(Button, {
    type: "submit",
    disabled: !form.isValid || form.isSubmitting,
    onClick: handleClick,
    ...props
  });
}
function PreviousButton({
  children,
  ...props
}) {
  const form = useFormikContext();
  return jsxs(Fragment, {
    children: [jsx(Mobile, {
      children: jsx(ButtonBase, {
        className: "h-button w-full bg-navy md:hidden",
        disabled: form?.isSubmitting,
        ...props,
        children: jsx(Text, {
          fontWeight: "semibold",
          className: "text-white",
          children: children
        })
      })
    }), jsx(Desktop, {
      children: jsx("div", {
        className: "hidden md:block",
        children: jsx(Button, {
          variant: "text",
          disabled: form?.isSubmitting,
          ...props,
          children: jsxs("div", {
            className: "flex h-button items-center",
            children: [jsx(IconBack, {
              width: 17,
              className: "mr-xs hover:text-dark-navy"
            }), ' ', children]
          })
        })
      })
    })]
  });
}
function ErrorMessage({
  message
}) {
  return jsx(Text, {
    variant: "p1",
    className: "mt-xs text-red",
    children: message
  });
}
Form.SubmitButton = SubmitButton;
Form.PreviousButton = PreviousButton;
Form.ErrorMessage = ErrorMessage;

export { Form };
